export default {
    centerVertical: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
    }
}